<template>
    <div class="warranty-status-piechart">
        <div class="row mt-4">
            <div class="cols-sm-12 col-md-12 col-lg-12">
                <h3 class="mb-4">
                    All Warranties by products<br />
                    <span class="bg-secondary text-white px-4 pt-2 pb-1 inline-block">{{ totalWarranties }}</span>
                </h3>
            </div>

            <div class="col-sm-12 col-md-12 col-lg-12">
                <div class="bar-graph">
                    <!-- <apexchart v-if="!loading" type="bar" :height="barSeries[0].data.length * 80" :options="barChartOptions" :series="barSeries" />
                    <div v-else class="text-center">
                        <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                        </div>
                    </div> -->

                    <div class="bar-graph-legend mt-4">
                        <div class="bar-graph-legend-item" v-for="(item, index) in barGraphData" :key="index">
                            <div class="bar-graph-legend-item-color">
                                <span
                                    class="bar-graph-legend-item-percentage"
                                    :style="{width: item.percentage + '%', backgroundColor: item.color_code}"
                                ></span>
                                <span class="bar-graph-count">{{ item.tickets }}</span>
                            </div>
                            <div class="bar-graph-legend-item-name">
                                {{ item.product_name || item.product_sku }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// import VueApexCharts from 'vue-apexcharts';
import AuthApis from '@/controllers/AuthApis';
import Env from '@/env';
import moment from 'moment';
export default {
    name: 'WarrantyByProductsBarChart',
    components: {
        // apexchart: VueApexCharts
    },
    props: {
        startDate: {
            type: [Date, String],
            required: false,
            default: null
        },
        endDate: {
            type: [Date, String],
            required: false,
            default: null
        }
    },
    computed: {},
    data() {
        return {
            genericColorCodes: ['#e70413', '#146081', '#000000'],
            barGraphData: [],
            loading: true,
            totalWarranties: 0,
            // Bar Chart Series
            barSeries: [
                {
                    name: 'Warranty by Products',
                    data: [] // value array
                }
            ],
            // Bar Chart Options
            barChartOptions: {
                tooltip: {
                    theme: 'dark',
                    style: {
                        background: '#e70413',
                        color: '#fff',
                        fontSize: '14px'
                    }
                },
                states: {
                    hover: {
                        filter: {
                            type: 'none'
                        },
                        fill: {
                            color: '#e70413' // black on hover
                        }
                    }
                },
                grid: {
                    show: false
                },
                chart: {
                    type: 'bar'
                },

                plotOptions: {
                    bar: {
                        barHeight: '90%',
                        horizontal: true,
                        distributed: true,
                        dataLabels: {
                            position: 'center'
                        }
                    }
                },
                colors: [], // colors array
                dataLabels: {
                    enabled: true,

                    // offsetX: 300,
                    // offsetY: 10,
                    style: {
                        colors: ['#000000'],
                        fontSize: '18px',
                        fontWeight: 'bold'
                        // marginRight: '-110px'
                    },
                    dropShadow: {
                        enabled: false
                    }
                },
                xaxis: {
                    axisTicks: {
                        show: false
                    },
                    axisBorder: {
                        show: false
                    },

                    show: false,
                    categories: [], // name array
                    labels: {
                        show: false,
                        style: {
                            fontSize: '14px' // month labels bigger
                        }
                    }
                },
                yaxis: {
                    show: true,
                    labels: {
                        style: {
                            fontSize: '10px', // month labels bigger
                            colors: '#000000'
                        }
                    }
                }
            }
        };
    },
    mounted() {
        this.getWarrantyStatsByProduct();
    },
    methods: {
        getRandomLightColor() {
            // Generate RGB values between 180 and 255 (light range)
            const r = Math.floor(180 + Math.random() * 75);
            const g = Math.floor(180 + Math.random() * 75);
            const b = Math.floor(180 + Math.random() * 75);

            // Convert to hex and pad with 0 if needed
            const toHex = (val) => val.toString(16).padStart(2, '0');

            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        },
        getRandomDarkColor() {
            // Generate RGB values between 0 and 100 (dark range)
            const r = Math.floor(Math.random() * 100);
            const g = Math.floor(Math.random() * 100);
            const b = Math.floor(Math.random() * 100);
            const toHex = (val) => val.toString(16).padStart(2, '0');
            return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        },
        getWarrantyStatsByProduct() {
            let url = `${Env.baseUrl}/v2/superadmin/reg-product/get-warranty-tickets-count-by-product`;
            if (this.startDate && this.endDate) {
                const startDateStr = typeof this.startDate === 'string' ? this.startDate : moment(this.startDate).format('YYYY-MM-DD');
                const endDateStr = typeof this.endDate === 'string' ? this.endDate : moment(this.endDate).format('YYYY-MM-DD');
                url += `?startDate=${startDateStr}&endDate=${endDateStr}`;
            }
            AuthApis.getApi(url)
                .then((res) => {
                    this.totalWarranties = res.data.payload.reduce((acc, item) => acc + item.tickets, 0);
                    this.barGraphData = res.data.payload.map((d) => {
                        return {
                            ...d,
                            // product_name: d.product_name,
                            // product_sku: d.product_sku,
                            // tickets: d.tickets,
                            percentage: (d.tickets / this.totalWarranties) * 100
                        };
                    });
                    // colors done
                    this.barChartOptions.colors = res.data.payload.map(() => this.getRandomLightColor());
                    // data count
                    this.barSeries[0].data = res.data.payload.map((item) => item.tickets);
                    // name
                    this.barChartOptions.xaxis.categories = res.data.payload.map((item) => item.product_name);
                    // total warranties
                    this.totalWarranties = res.data.payload.reduce((acc, item) => acc + item.tickets, 0);
                    this.loading = false;
                })
                .catch((err) => {
                    this.loading = false;
                    console.log(err);
                });
        }
    }
};
</script>
